import Model from 'flarum/common/Model';
export default class PollOptionTranslation extends Model {
  optionId() {
    return String(Model.attribute('optionId').call(this));
  }
  language() {
    return Model.attribute('language').call(this);
  }
  answer() {
    return Model.attribute('answer').call(this);
  }
}
flarum.reg.add('fof-translate', 'common/models/PollOptionTranslation', PollOptionTranslation);